export default __webpack_public_path__ + "static/media/LC.df15ef78.svg";